var QueryKey;
(function (QueryKey) {
  QueryKey["submitAccountVerification"] = "submitAccountVerification";
  QueryKey["updateAccount"] = "updateAccount";
})(QueryKey || (QueryKey = {}));

export { QueryKey };
